<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <horizontal-stepper 
          :steps="steps" 
          locale= "es"
          @completed-step="completeStep"
          @active-step="isStepActive" 
          @stepper-finished="registrarPagoResumen"
          :keep-alive="Boolean(true)"
          :top-buttons="Boolean(true)">
        </horizontal-stepper>          
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import HorizontalStepper from 'vue-stepper';
import OpcionPago from './OpcionPago.vue';
import Documentos from './Documentos.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'tarjetaResumenPago/getField',
  mutationType: 'tarjetaResumenPago/updateField',
});

export default {
  name: 'TarjetaResumenPagoABM',
  components: {
    HorizontalStepper,
    OpcionPago,
    Documentos,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      steps: []
    }
  },
  computed: {
    ...mapFields([
      'totalDocumentos',
      'totalSeleccionado',
      'cuentaCorrienteSaldoId'
    ]),
  },
  created() {
    // console.log(this.impuestos);

    this.steps = [
      {
          icon: '',
          name: 'opcion-pago',
          title: 'Opción de Pago',
          subtitle: 'Seleccione la opción de pago',
          component: OpcionPago,
          completed: false

      },
      {
          icon: '',
          name: 'documentos',
          title: 'Ingreso de Documentos',
          subtitle: 'Ingrese los documentos cancelatorios',
          component: Documentos,
          completed: false
      },
    ]

    let tarjetaResumenId = 0;
    if (this.$route.params){
      if (this.$route.params.tarjetaResumenId){
        tarjetaResumenId = this.$route.params.tarjetaResumenId;
      }
    }

    this.$store.dispatch('tarjetaResumenPago/inicializar', tarjetaResumenId);
  },  
  methods: {
    completeStep(payload) {
        this.steps.forEach((step) => {
            if (step.name === payload.name) {
                step.completed = true;
            }
        })
    },
    // Executed when @active-step event is triggered
    isStepActive(payload) {
        this.steps.forEach((step) => {
            if (step.name === payload.name) {
                if(step.completed === true) {
                    step.completed = false;
                }
            }
        })
    },
    registrarPagoResumen () {
      this.showSpinner();
      this.$store.dispatch('tarjetaResumenPago/save')
        .then(() => this.showModalMsj('El pago del resumen se registró con éxito.', 
          this.goList, this.goList, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    goList() {
      this.$router.push({ name: 'TarjetasResumenes' });
    },
  },
  watch: {
  },
}
</script>

<style>
</style>
